export const diagnosticColors: string[] = ['#999999', '#2CC852', '#FFDE31', '#E74150'];
